export interface Environment {
  production: boolean;
  apiUrl: string;
  apiVersionMain: string;
  outcomeUrl: string;
  apiVersionOutcome: string;
  positionUrl: string;
  garageUrl: string;
  apiVersionGarage: string;
  routeUrl: string;
  apiVersionRoute: string;
  appInsights: {
    instrumentationKey: string;
    isEnabled: boolean;
  };
  language: string;
  enableBilling: boolean;
  enableUnboundOrder: boolean;
  environmentType: EnvironmentType;
  enableDeviationPage: boolean;
  b2c: B2cConfig;
}

export enum EnvironmentType {
  Production = 'Production',
  ST = 'ST',
  AT = 'AT',
  FT = 'FT',
  LocalST = 'Local ST',
  LocalFT = 'Local FT',
  LocalLocal = 'Local Local',
}

export interface B2cConfig {
  mainServiceScopes: string[];
  garageServiceScopes: string[];
  routeServiceScopes: string[];
  outcomeServiceScopes: string[];
  iotFunctionsServiceScopes: string[];
  authorityDomain: string;
  authority: string;
  clientId: string;
  tenantId: string;
  redirectUrl: string;
}
